import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form } from 'antd'
import { RuleStudio } from './RuleStudio'

export function NotificationRuleEdit() {
  const { formProps, saveButtonProps } = useForm({ resource: 'notification_rules' })

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <RuleStudio />
      </Form>
    </Edit>
  )
}
